@if (selectedECar(); as selectedCar) {
  @if (historySelector) {
    <div class="car-icon-row">
      <img class="car-image" appVehicleImageFallback [src]="VEHICLE_IMAGE_URL.replace('$skin',  settingsService.getMap().Skin).replace('$icon_name', selectedCar.ECarType?.Icon ?? '')" />
    </div>
  }
  <mat-form-field class="modal-select-field user-cars-select" data-testid="veh-selector-container">
    <mat-select disableRipple [(value)]="selectedECar" class="brand-mat-select"
      data-testid="veh-selector-select"
      panelClass="modal-select-panel user-cars-panel"
      (selectionChange)="selectionChanged()">
      <mat-select-trigger>
        @if (!historySelector) {
          <img class="vehicle-img" appVehicleImageFallback [src]="VEHICLE_IMAGE_URL.replace('$skin', 'dark').replace('$icon_name', selectedCar.ECarType?.Icon ?? '')" />
        }
        @if (selectedCar.name) {
          <span class="vehicle-name"> {{ selectedCar.name }} </span>
        }
        @if (!selectedCar.name) {
          <span class="vehicle-name"> {{ selectedCar.ECarType?.Name }} </span>
        }
      </mat-select-trigger>
      @for (userECar of userECars(); track userECar; let i = $index) {
        <mat-option class="user-cars-option" [value]="userECar" [attr.data-testid]="'veh-selector-option-' + i">
          @if (!historySelector) {
            <img class="vehicle-img" appVehicleImageFallback [src]="VEHICLE_IMAGE_URL.replace('$skin', 'dark').replace('$icon_name', userECar.ECarType?.Icon ?? '')" />
          }
          @if (userECar.name) {
            <span class="vehicle-name"> {{ userECar.name }} </span>
          }
          @if (!userECar.name) {
            <span class="vehicle-name"> {{ userECar.ECarType?.Name }} </span>
          }
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}
